import type {ComponentProps} from '@enonic/react-components'
import * as React from 'react'
import {Section, Container, PersonCard} from '../primitives'
import type {PersonCardProps, PersonCardVariant} from '../primitives'

export interface PersonListData extends Record<string, unknown> {
    heading: string
    backgroundColor: 'none' | 'light-blue' | 'light-peach'
    featuredPersons: PersonCardProps[]
    persons: PersonCardProps[]
}

const bgMap: Record<PersonListData['backgroundColor'], string> = {
    none: '',
    'light-blue': 'bg-slate-100',
    'light-peach': 'bg-peach-100',
}

const featuredLayout = (count: number): {variant: PersonCardVariant; span: string} => {
    if (count === 3) return {variant: 'medium', span: 'col-span-full md:col-span-4'}
    return {variant: 'large', span: 'col-span-full md:col-span-6'}
}

const normalLayout = {
    variant: 'small' as PersonCardVariant,
    span: 'col-span-full md:col-span-3',
}

export const PersonList = (props: ComponentProps) => {
    const {heading, backgroundColor, featuredPersons, persons} = props.data as PersonListData
    const featured = featuredLayout(featuredPersons.length)

    return (
        <Section background={bgMap[backgroundColor]}>
            <Container className="gap-y-6 md:gap-y-12">
                {heading && (
                    <h2 className="col-span-full text-3xl leading-tight text-blue-900 md:text-6xl md:leading-snug">
                        {heading}
                    </h2>
                )}

                {featuredPersons.map((person) => (
                    <PersonCard
                        key={person.id}
                        {...person}
                        variant={featured.variant}
                        className={featured.span}
                    />
                ))}

                {persons.map((person) => (
                    <PersonCard
                        key={person.id}
                        {...person}
                        variant={normalLayout.variant}
                        className={normalLayout.span}
                    />
                ))}
            </Container>
        </Section>
    )
}
